export const SET_VOLUME = 'SET_VOLUME'
export const SET_PLAY_LOADING = 'SET_PLAY_LOADING'
export const ON_POPUP = 'ON_POPUP'
export const ON_TRACK = 'ON_TRACK'
export const ON_TRACK_QUEU = 'ON_TRACK_QUEU'
export const ON_PARTY_START = 'ON_PARTY_START'
export const ON_PARTY_CHANGE = 'ON_PARTY_CHANGE'
export const ON_MESSAGES = 'ON_MESSAGES'
export const ON_MEDIA_SUPPORT_ERROR = 'ON_MEDIA_SUPPORT_ERROR'
export const ON_ADMIN_SAVE = 'ON_ADMIN_SAVE'
export const ON_OVERLAY_OPEN = 'ON_OVERLAY_OPEN'
